// extracted by mini-css-extract-plugin
export default {"page":"Page_page__L2Y9k","inner":"Page_inner__NzybS","innerStickyHeader":"Page_innerStickyHeader__6Nu-7"};